module.exports = __webpack_public_path__ + "thumbs-up.ff4e7c000e929bdf46c9ad8049a1e8e2.svg";